import React from 'react';
import RequestAssetsForm from '../components/RequestAssetsForm';

const AssetsRequest = () => {
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '40px' }}> طلب عهدة جديدة</h1>
      </div>
      <RequestAssetsForm />
    </>
  );
};

export default AssetsRequest;
